import { render, staticRenderFns } from "./IosWebviewButNotAppWarning.vue?vue&type=template&id=7e59a335&"
import script from "./IosWebviewButNotAppWarning.vue?vue&type=script&lang=ts&"
export * from "./IosWebviewButNotAppWarning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
